import { AxiosError } from "axios"

interface RequestError {
  message: string
}

export default function returnBackendErrors(error: any): string {
  if ((error as AxiosError).response) {
    return ((error as AxiosError).response?.data as RequestError)?.message
  } else {
    return (error as AxiosError).message
  }
}
